module.exports = __webpack_public_path__ + "img/num_49.29ccbdcc.png";